export interface ICulture {
  culture: string;
  name: string;
}
